import { FC } from "react";

import { FormikHelpers, FormikErrors, FormikComputedProps } from "formik";

import Typography from "@mui/material/Typography";
import FormControlLabel from "@mui/material/FormControlLabel";

import CustomCheckbox from "components/CustomCheckbox";

import styles from "./styles";

export interface ConsentsFormValues {
  personalDataChecked: boolean;
  marketingChecked: boolean;
}

type ConsentsFieldsProps = {
  onChange: FormikHelpers<ConsentsFormValues>["setFieldValue"];
  errors: FormikErrors<ConsentsFormValues>;
  isValid: FormikComputedProps<ConsentsFormValues>["isValid"];
};

const ConsentsFields: FC<ConsentsFieldsProps> = ({
  onChange,
  errors,
  isValid,
}) => {
  return (
    <>
      <FormControlLabel
        value="end"
        defaultChecked={false}
        control={<CustomCheckbox />}
        label={
          <Typography
            component="span"
            variant="subtitle1"
            fontWeight="light"
            sx={errors.personalDataChecked ? styles.error : {}}
          >
            I agree to the use and processing of my personal data during the
            redeem process*
          </Typography>
        }
        labelPlacement="end"
        onChange={(_, checked) => {
          onChange("personalDataChecked", checked);
        }}
      />
      <FormControlLabel
        value="end"
        defaultChecked={false}
        control={<CustomCheckbox />}
        label={
          <Typography component="span" variant="subtitle1" fontWeight="light">
            I agree to the processing of my personal data for marketing purposes
            by Uniqly
          </Typography>
        }
        labelPlacement="end"
        onChange={(_, checked) => {
          onChange("marketingChecked", checked);
        }}
      />
      <Typography variant="body2" sx={isValid ? {} : styles.error}>
        *Required consents / fields
      </Typography>
    </>
  );
};

export default ConsentsFields;
